exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card .box-header a[data-v-68be075b]:hover {\n    background-color: #eee !important;\n    border-bottom: 0;\n    text-decoration: none;\n}\nselect[data-v-68be075b] {\n    height: 37px;\n}\n", ""]);

// exports
